import { render, staticRenderFns } from "./EditConsultantTalentForm.vue?vue&type=template&id=2866e51d&"
import script from "./EditConsultantTalentForm.vue?vue&type=script&lang=ts&"
export * from "./EditConsultantTalentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports